import UiSettingsEditor from "./UiSettingsEditor";
export default {
  settingsSchema: null,
  component: UiSettingsEditor,
  hideLabel: true
};
//# sourceMappingURL=UiSettingsEditor.meta.js.map
